const cache = {};
export const useFetchUrlCache = (url) => {
  if (cache[url]) {
    return cache[url];
  }
  cache[url] = fetch(url).then((data) => data.json());
  return cache[url];
};
